import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
const CannotUploadFile = ({ maxSize }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content cannot-upload-file', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.file_is_too_large'), type: 'h1' }) }), _jsx("div", { className: "modal-content-description", children: t('admin.cannot_upload_file', { maxSize }) }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: 'OK', onClick: async () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                    } }) })] }));
};
export default CannotUploadFile;
